import { render } from "./LegacyGroupOccupancyReport.vue?vue&type=template&id=69eddbcb"
import script from "./LegacyGroupOccupancyReport.vue?vue&type=script&lang=js"
export * from "./LegacyGroupOccupancyReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__